import angular from 'angular';

/* @ngInject */
export default function SpinnerLoadingService($translate) {
    const progressIndicator = document.getElementById('progressSpinner');
    const body = document.getElementsByTagName('body')[0];
    const messageEl = document.getElementById('spinnerText');

    return {
        showLoading: function (loadingMessage) {
            $translate('label__loading__waiting', 'en').then(function (defaultWaitingMessage) {
                if (loadingMessage) {
                    messageEl.innerText = loadingMessage;
                } else {
                    messageEl.innerText = defaultWaitingMessage;
                }

                angular.element(progressIndicator).removeClass('hidden');
                angular.element(body).addClass('no-scroll');
            });
        },
        hideLoading: function () {
            $translate('label__loading__waiting', 'en').then(function (defaultWaitingMessage) {
                angular.element(progressIndicator).addClass('hidden');
                angular.element(body).removeClass('no-scroll');
                // Reset the message
                messageEl.innerText = defaultWaitingMessage;
            });
        }
    };
}
